import { Link } from "react-router-dom";

export default function About() {
  return (
    <div className="bg-[#FFF4E0]" data-testid="about-page">
      <section className="max-w-[1400px] mx-auto px-6 md:px-12 lg:px-16 py-20 md:py-28 grid grid-cols-1 lg:grid-cols-12 gap-12 items-center">
        <div className="lg:col-span-6 order-2 lg:order-1">
          <div className="overline mb-3">The House</div>
          <h1 className="font-serif-display text-5xl md:text-7xl text-[#1A0F11] leading-[0.95]">A crown<br/><em className="italic text-[#831132]">for every queen.</em></h1>
          <p className="text-[#5C4A4D] mt-8 leading-relaxed">
            The Hair Bu&apos;tik was founded by Yetunde Olatunde with a single vision — to give women a premium hair house that treats their crown with the reverence it deserves.
          </p>
          <p className="text-[#5C4A4D] mt-4 leading-relaxed">
            Every wig, every bundle, every frontal in our collection is hand-selected from trusted single donors, obsessively quality-checked, and finished in our London studio before being couriered to your door anywhere in the world.
          </p>
          <p className="text-[#5C4A4D] mt-4 leading-relaxed">
            From the boardrooms of London to the streets of Lagos — when you wear The Hair Bu&apos;tik, you wear a quiet kind of confidence that lets the room come to you.
          </p>
          <Link to="/shop" className="btn-primary mt-10 inline-flex" data-testid="about-shop-cta">Shop the collection</Link>
        </div>
        <div className="lg:col-span-6 order-1 lg:order-2">
          <img src="https://images.unsplash.com/photo-1668815142412-c912ff69ae15?w=1200" alt="The Hair Bu'tik — premium hair house" className="w-full aspect-square object-cover" />
        </div>
      </section>

      <section className="bg-[#831132] text-[#FFF4E0] py-24">
        <div className="max-w-[1400px] mx-auto px-6 md:px-12 lg:px-16 grid grid-cols-1 md:grid-cols-3 gap-12">
          {[
            { t: "Luxury", d: "Hand-tied HD lace, single-donor raw hair. No shortcuts, ever." },
            { t: "Curated", d: "Every piece is reviewed three times before it earns the Hair Bu'tik seal." },
            { t: "Confidence", d: "We don't sell hair. We sell the moment you catch your reflection and smile." },
          ].map((p, i) => (
            <div key={i}>
              <div className="overline text-[#C5A059]">0{i+1}</div>
              <h3 className="font-serif-display text-3xl mt-2">{p.t}</h3>
              <p className="text-[#FFF4E0]/80 mt-3 leading-relaxed">{p.d}</p>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
}
